import { cn } from '../cn';

import type { DataTableColumn, SortState } from './types';

interface Props<T> {
  column: DataTableColumn<T>;
  sort: SortState | null;
  onSortChange: ((s: SortState | null) => void) | null;
}

export function HeaderCell<T>({ column, sort, onSortChange }: Props<T>): JSX.Element {
  const isSorted = sort?.id === column.id;
  const dir = isSorted ? sort?.dir : null;
  const baseClass = cn(
    'px-4 py-2 font-medium',
    column.align === 'end' && 'text-end',
    column.hideOnMobile && 'hidden sm:table-cell',
  );
  if (!column.sortable || !onSortChange) {
    return (
      <th scope="col" className={baseClass}>
        {column.header}
      </th>
    );
  }
  const next: SortState =
    isSorted && dir === 'asc' ? { id: column.id, dir: 'desc' } : { id: column.id, dir: 'asc' };
  return (
    <th scope="col" className={baseClass}>
      <button
        type="button"
        onClick={() => onSortChange(isSorted && dir === 'desc' ? null : next)}
        className="inline-flex items-center gap-1 hover:text-foreground"
        data-testid={`datatable-sort-${column.id}`}
      >
        {column.header}
        <span aria-hidden="true" className="text-[10px]">
          {isSorted ? (dir === 'asc' ? '▲' : '▼') : '↕'}
        </span>
      </button>
    </th>
  );
}
